/* eslint-disable indent */
/* eslint-disable prettier/prettier */
import { ObjectId } from 'bson';
import { _BaseModel } from './helpers/_BaseModel';
_BaseModel.addDictionary({modelName:'WorkerTimeReport',dictionary:{"de":{"references":{"responsibleWorker":"Verantwortlicher Mitarbeiter","lessonsLearned":"Erkenntnisse"},"workerTimeReportId":"TAB-ID","date":"Datum","remark":"Anmerkung","status":"Status","__getters":{"calendarWeek":"Kalenderwoche","dateCalendarWeek":"Datum","dateCalendarWeekDay":"Datum","projectList":"Projekte"}},"en":{"references":{"responsibleWorker":"Responsible Worker","lessonsLearned":"Lessons learned"},"workerTimeReportId":"TAB-ID","date":"Date","remark":"Remark","status":"Status","__getters":{"calendarWeek":"Calenderweek","dateCalendarWeek":"Date","dateCalendarWeekDay":"Date","projectList":"Projects"}}}})
import { Login } from './Login';
import { Worker } from './Worker';
import { LessonsLearned } from './LessonsLearned';
import { Project } from './Project';
import { WorkRecord } from './WorkRecord';
import { WorkTime } from './WorkTime';
import { Absence } from './Absence';
import _ from 'lodash';

export class WorkerTimeReport extends _BaseModel {
	
	static toString() {
		return 'WorkerTimeReport'
	}
	
	get __getters() {
		const self = this;
		return {
			get calendarWeek() {
        // eslint-disable-next-line no-undef
        return _BaseModel.getFunctions.calendarWeek(self.date);
    },
			get dateCalendarWeek() {
        // eslint-disable-next-line no-undef
        return _BaseModel.getFunctions.dateCalendarWeek(self.date);
    },
			get dateCalendarWeekDay() {
        // eslint-disable-next-line no-undef
        return _BaseModel.getFunctions.dateCalendarWeekDay(self.date);
    },
			get dateLongInt() {
        // eslint-disable-next-line no-undef
        return _BaseModel.getFunctions.dateLongInt(self.date);
    },
			get projectList() {
        const projects = _.get(self.references, 'workRecords').map((item) => _.get(item, 'references.project', {}));

        const uniqueProjects = _.uniqBy(projects, (item) => item._id);

        // return uniqueProjects.map((item) => item.projectId + '-' + item.general.name).join(', ');
        return uniqueProjects.map((item) => item.general.name).join(', ');
    },
		}
	}
	
	static get paths() {
		return 			{
			meta: 				{
					
	locked:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WorkerTimeReport.meta.locked'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WorkerTimeReport', path:'meta.locked'}) ],
},
    
	},
	
					
	createdAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkerTimeReport.meta.createdAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkerTimeReport', path:'meta.createdAt'}) ],
},
    
	},
	
					
	updatedAt:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkerTimeReport.meta.updatedAt'),
				rules: [ (value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkerTimeReport', path:'meta.updatedAt'}) ],
},
    
	},
	
					
	createdBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WorkerTimeReport', path:'meta.createdBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	updatedBy:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Login'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Login) || _BaseModel.t('rules.reference', {modelName:'WorkerTimeReport', path:'meta.updatedBy'}) ],
				model: Login,
				returnObject: true,
},
    
	},
	
					
	archived:{
		type: 'boolean',
		__component: 'v-checkbox',
    __get: _BaseModel.getFunctions.boolean,
		__bind: {				label: _BaseModel.t('models.WorkerTimeReport.meta.archived'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'boolean') || _BaseModel.t('rules.type.boolean', {modelName:'WorkerTimeReport', path:'meta.archived'}) ],
},
    
	},
	
					
	currentDocument:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkerTimeReport'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof WorkerTimeReport) || _BaseModel.t('rules.reference', {modelName:'WorkerTimeReport', path:'meta.currentDocument'}) ],
				model: WorkerTimeReport,
				returnObject: true,
},
    
	},
	
					
	revisions:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models._Revision'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WorkerTimeReport', path:'meta.revisions'}) ],
				model: WorkerTimeReport,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
			references: 				{
					
	responsibleWorker:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkerTimeReport', path:'references.responsibleWorker'}),(value) => (value === undefined || value === null || typeof value === 'string' || value instanceof Worker) || _BaseModel.t('rules.reference', {modelName:'WorkerTimeReport', path:'references.responsibleWorker'}) ],
				model: Worker,
				returnObject: true,
},
    
	},
	
					
	lessonsLearned:{
		type: 'objectId',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.LessonsLearned'),
				rules: [ (value) => (value === undefined || value === null || typeof value === 'string' || value instanceof LessonsLearned) || _BaseModel.t('rules.reference', {modelName:'WorkerTimeReport', path:'references.lessonsLearned'}) ],
				model: LessonsLearned,
				returnObject: true,
},
    
	},
	
					
	workers:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Worker'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WorkerTimeReport', path:'references.workers'}) ],
				model: Worker,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	projects:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Project'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WorkerTimeReport', path:'references.projects'}) ],
				model: Project,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	workRecords:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkRecord'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WorkerTimeReport', path:'references.workRecords'}) ],
				model: WorkRecord,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	workTimes:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.WorkTime'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WorkerTimeReport', path:'references.workTimes'}) ],
				model: WorkTime,
				returnObject: true,
				multiple: true,
},
    
	},
	
					
	absences:{
		type: 'array',
		__component: 'model-autocomplete',
    
		__bind: {				label: _BaseModel.t('$global.models.Absence'),
				rules: [ (value) => (value === undefined || value === null || Array.isArray(value)) || _BaseModel.t('rules.array', {modelName:'WorkerTimeReport', path:'references.absences'}) ],
				model: Absence,
				returnObject: true,
				multiple: true,
},
    
	},
	
},
				
	workerTimeReportId:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.WorkerTimeReport.workerTimeReportId'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'WorkerTimeReport', path:'workerTimeReportId'}) ],
},
    
	},
	
				
	date:{
		type: 'date',
		__component: 'date-picker',
    
		__bind: {				label: _BaseModel.t('models.WorkerTimeReport.date'),
				rules: [ (value) => !!value || _BaseModel.t('rules.required', {modelName:'WorkerTimeReport', path:'date'}),(value)=>  (value === undefined || value === null || value instanceof Date) || _BaseModel.t('rules.type.date', {modelName:'WorkerTimeReport', path:'date'}) ],
},
    __isDate: true,
	},
	
				
	remark:{
		type: 'string',
		__component: 'v-textarea',
    
		__bind: {				label: _BaseModel.t('models.WorkerTimeReport.remark'),
				rows: 1,
				autoGrow: true,
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'WorkerTimeReport', path:'remark'}) ],
},
    
	},
	
				
	status:{
		type: 'string',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.WorkerTimeReport.status'),
				rules: [ (value)=> (value === undefined || value === null || typeof value === 'string') || _BaseModel.t('rules.type.string', {modelName:'WorkerTimeReport', path:'status'}) ],
},
    
	},
	
				
	_id:{
		type: 'objectId',
		__component: 'v-text-field',
    
		__bind: {				label: _BaseModel.t('models.WorkerTimeReport._id'),
				rules: [  ],
},
    
	},
	
}
	}
	constructor({meta={}, references={}, workerTimeReportId='', date=undefined, remark='', status='', _id=new ObjectId(), }={}){
		super();
		this.meta=MetaClass.create(meta);
		this.references=ReferencesClass.create(references);
		this.workerTimeReportId=workerTimeReportId;
		this.date=date;
		this.remark=remark;
		this.status=status;
		this._id=_id;
	}

	static create(data) {
		return new WorkerTimeReport(data);
	}
}

class MetaClass {
	constructor({locked=false, createdAt=undefined, updatedAt=undefined, createdBy=undefined, updatedBy=undefined, archived=false, currentDocument=undefined, revisions=[], __errors=[], }={}){
		this.locked=locked;
		this.createdAt=createdAt;
		this.updatedAt=updatedAt;
		this.createdBy= (createdBy instanceof Login || typeof createdBy === 'string' || !createdBy) ? createdBy : Login.create(createdBy);
		this.updatedBy= (updatedBy instanceof Login || typeof updatedBy === 'string' || !updatedBy) ? updatedBy : Login.create(updatedBy);
		this.archived=archived;
		this.currentDocument= (currentDocument instanceof WorkerTimeReport || typeof currentDocument === 'string' || !currentDocument) ? currentDocument : WorkerTimeReport.create(currentDocument);
		if(Array.isArray(revisions)){
			this.revisions=[];
			for(const item of revisions){
				if(typeof item === 'string') this.revisions.push(item)
				else if(typeof item === 'object')
					this.revisions.push(item instanceof WorkerTimeReport ? item : WorkerTimeReport.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.revisions=revisions;
		}
		this.__errors=__errors;
	}

	static create(data) {
		return new MetaClass(data);
	}
}

class ReferencesClass {
	constructor({responsibleWorker=undefined, lessonsLearned=undefined, workers=[], projects=[], workRecords=[], workTimes=[], absences=[], }={}){
		this.responsibleWorker= (responsibleWorker instanceof Worker || typeof responsibleWorker === 'string' || !responsibleWorker) ? responsibleWorker : Worker.create(responsibleWorker);
		this.lessonsLearned= (lessonsLearned instanceof LessonsLearned || typeof lessonsLearned === 'string' || !lessonsLearned) ? lessonsLearned : LessonsLearned.create(lessonsLearned);
		if(Array.isArray(workers)){
			this.workers=[];
			for(const item of workers){
				if(typeof item === 'string') this.workers.push(item)
				else if(typeof item === 'object')
					this.workers.push(item instanceof Worker ? item : Worker.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.workers=workers;
		}
		if(Array.isArray(projects)){
			this.projects=[];
			for(const item of projects){
				if(typeof item === 'string') this.projects.push(item)
				else if(typeof item === 'object')
					this.projects.push(item instanceof Project ? item : Project.create(item))
				else throw new Error('unknown type for '+item)
			}
		} else {
			this.projects=projects;
		}
		if(Array.isArray(workRecords)){
			this.workRecords=[];
			for(const item of workRecords){
				if(typeof item === 'object')
					this.workRecords.push(item instanceof WorkRecord ? item : WorkRecord.create(item))
				else this.workRecords.push(item)
			}
		} else {
			this.workRecords=workRecords;
		}
		if(Array.isArray(workTimes)){
			this.workTimes=[];
			for(const item of workTimes){
				if(typeof item === 'object')
					this.workTimes.push(item instanceof WorkTime ? item : WorkTime.create(item))
				else this.workTimes.push(item)
			}
		} else {
			this.workTimes=workTimes;
		}
		if(Array.isArray(absences)){
			this.absences=[];
			for(const item of absences){
				if(typeof item === 'object')
					this.absences.push(item instanceof Absence ? item : Absence.create(item))
				else this.absences.push(item)
			}
		} else {
			this.absences=absences;
		}
	}

	static create(data) {
		return new ReferencesClass(data);
	}
}
